import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
var CourseLearningHomeNoteComponent = (function () {
    function CourseLearningHomeNoteComponent(apiService, commonService, route, router) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.route = route;
        this.router = router;
        this.showCourse = false;
        this.learningPathId = 0;
        this.courseId = 0;
        this.firstEnter = 0;
        this.assetsRoute = "../../assets";
    }
    CourseLearningHomeNoteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.route.params.subscribe(function (params) {
            _this.learningPathId = params['learningPathId'];
            _this.courseId = params['courseId'];
            _this.firstEnter = params['firstEnter'];
            _this.getCourse();
        });
    };
    CourseLearningHomeNoteComponent.prototype.getCourse = function () {
        var _this = this;
        this.apiService.getCourse("" + this.courseId + "").subscribe(function (course) {
            _this.course = course;
            _this.showCourse = true;
        });
    };
    CourseLearningHomeNoteComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
        $('body').css("height", "auto");
    };
    // 关闭精华笔记
    CourseLearningHomeNoteComponent.prototype.closeNote = function () {
        var link = ["course", this.learningPathId, this.courseId, this.firstEnter];
        this.router.navigate(link);
    };
    CourseLearningHomeNoteComponent.prototype.openPDF = function (number) {
        window.open("../../assets/pdf/jinghua11-" + number + ".pdf", "_blank");
    };
    return CourseLearningHomeNoteComponent;
}());
export { CourseLearningHomeNoteComponent };



// WEBPACK FOOTER //
// ./src/app/course-learning-home/course-learning-home-note.component.ts.pre-build-optimizer.js